import { filter, map, retry, switchMap } from "rxjs/operators";
import { selectActiveCollectEvent, selectCloserCollectEvent, } from "../../../../selectors/selectCollectEvents";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { EventType } from "../../../balancing/types/BalancingCore";
import { TypeActionEventInfo } from "../../event/actionEventInfo";
import { actionPlayerLeagueInfo } from "../actionPlayerLeagueInfo";
export var epicCollectLeagueInfo = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) { return action.type === TypeActionEventInfo.Received; }), switchMap(function (action) {
        var state = state$.value;
        var eventToConsider = selectActiveCollectEvent(state) || selectCloserCollectEvent(state);
        return deps.netSend({
            id: CommandCode.CollectLeagueInfo,
            props: {
                eventId: eventToConsider.eventId,
                playerId: state$.value.playerInfo.playerId,
            },
        });
    }), retry(), map(function (res) { return actionPlayerLeagueInfo(res, EventType.CollectLeague); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/league/epics/epicCollectLeagueInfo.ts
// module id = 1911
// module chunks = 3